import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
// import useSignIn from 'react-auth-kit/hooks/useSignIn';  v3
import { useSignIn, useAuthUser } from 'react-auth-kit';
import { Navigate} from "react-router-dom";
import _ from 'lodash';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


// GRAPHQL QUERY
import { LoginMutation } from './auth_graphql.js';

export function LoginComponent(props) {

    // const navigate = useNavigate();
    const signIn = useSignIn();
    const auth = useAuthUser();
    const [login_check] = useMutation(LoginMutation);

    const [LoginState, setLoginState] = useState({
        create_account: '',
        display_form: 'login',
        email: '',
        first_name: '',
        last_name: '',
        new_password: '',
        password: '',
        phone_number: ''
    });

	// let logoImage = "cs_logo_small.png";

    // set background images
	let style = {};

	// if(props.Account.accountPrefix === "loyalpaws") {
	// 	let bgNumber = 1;
	// 	style.backgroundImage = `url(/images/ui/${props.Account.accountPrefix}_background${bgNumber}.jpg)`;
	// 	style.backgroundSize = 'cover';
	// 	style.backgroundPosition = 'center center';
	// 	style.backgroundRepeat = 'no-repeat';
	// } else {
	// 	style.backgroundColor = '#DDD';
	// }


    function changeValue(name, value, type='') {
        let new_value = value;
        if(type === 'checkbox') {
            if(new_value === "" || new_value === false || new_value === 'false' || parseInt(new_value) === 0) {
                new_value = 1;
            } else {
                new_value = 0
            }
        }
        setLoginState({
            ...LoginState,
            [name]: new_value
        })

    };

    function handleCodeSubmission() {
        console.log("handle code submission")
    }

    function handleCreateAccount(account_type) {
        setLoginState({
            ...LoginState,
            create_account: account_type,
            display_form: 'create_account',
            email: '',
            first_name: '',
            last_name: '',
            new_password: '',
            password: '',
            phone_number: ''
        })
    }

    async function handleLogin() {
        const result = await login_check({ variables: { input: { ..._.omit(LoginState, ['create_account', 'display_form', 'first_name', 'last_name', 'new_password'] ) } } });
console.log({result})
        // Setup cookies and signin if valid user is returned
        if ( parseInt(result.data.login && result.data.login.user_ID) > 0 ) {

            let Login = result.data.login;
            console.log({Login})
            
            let newAuthState = { ...Login };
            signIn({
                token: 345234523452345,
                expiresIn: 3600*16,
                tokenType: "Bearer",
                authState: { User: newAuthState }
            })

        }
        else {
            setLoginState({
                ...LoginState,
                logged_out_message: 'Invalid User Name and Password'
            })
        }

        // // One source
        //         // Create token
        //         const token = jwt.sign(
        //         { user_id: user._id, email },
        //         process.env.TOKEN_KEY,
        //         {
        //             expiresIn: "2h",
        //         }
        //         );
        //         // save user token
        //         user.token = token;

        //         // return new user
        //         res.status(201).json(user);

        // // Main youtube
        // const jwtToken = jwt.sign(
        //     { id: result.data.login.id, user_name: result.data.login.user_name },
        //     process.env.JWT_SECRET
        // );

        // res.json({ message: "Welcome Back!", token: jwtToken });


    }

    function handlePasswordReset() {
        console.log("password reset clicked")
    }

    // function handleSignup() {
    //     console.log("signup clicked")
    // }

    function CreateAccountForm() {
        // Disable Login button if the email or password are not completed inputs.
        let signup_disabled = (LoginState.create_account === 'Coach' && LoginState.email === "") || (LoginState.create_account === 'Player' && LoginState.phone_number === "") || LoginState.new_password === "" || LoginState.first_name === "" || LoginState.last_name === "";

        return (
            <div className="pb-5">
                <div className="h4 text-center mb-5" style={{color: '#e05900'}}>Create {LoginState.create_account} Account</div>
                <div className="h4 text-center">The NuShoulder Software is only available for elite athletes.<br />Enter your organization's {LoginState.create_account} code to be assigned to the correct program.</div>

                <div className="form-floating">
                    <input className="form-control" id="email" value={LoginState.code} onChange={(event) => changeValue('code', event.target.value)} />
                    <label htmlFor="code">Enter {LoginState.create_account} Code</label>
                </div>
                <div className="form-floating mt-2">
                    <input className="form-control" id="first_name" value={LoginState.first_name} onChange={(event) => changeValue('first_name', event.target.value)} />
                    <label htmlFor="first_name">First Name</label>
                </div>
                <div className="form-floating mt-2">
                    <input className="form-control" id="last_name" value={LoginState.last_name} onChange={(event) => changeValue('last_name', event.target.value)} />
                    <label htmlFor="last_name">Last Name</label>
                </div>
                {
                    LoginState.create_account === 'Coach' &&
                    <div className="form-floating mt-2">
                        <input className="form-control" id="email" value={LoginState.email} onChange={(event) => changeValue('email', event.target.value)} />
                        <label htmlFor="email">Email</label>
                    </div>
                }
                {
                    LoginState.create_account === 'Player' &&
                    <div className="form-floating mt-2">
                        <input className="form-control" id="phone_number" value={LoginState.phone_number} onChange={(event) => changeValue('phone_number', event.target.value)} />
                        <label htmlFor="phone_number">Phone Number</label>
                    </div>
                }
                <div className="form-floating mt-2">
                    <input className="form-control" id="email" value={LoginState.new_password} onChange={(event) => changeValue('new_password', event.target.value)} />
                    <label htmlFor="password">Password</label>
                </div>
                <div className="mt-2">
                    <button type="button" className={`btn text-white w-100`} disabled={signup_disabled} style={{backgroundColor: '#e05900'}} onClick={() => handleCodeSubmission()}>SIGN UP</button>
                </div>
                <img src={"/images/nushoulder_logo.png"} alt="" className="img-fluid my-5" />
                <div className="mt-2">
                    <button type="button" className={`btn text-dark w-100 fw-bolder border border-secondary bg-white`} onClick={() => changeValue('display_form', 'login')}>ALREADY HAVE AN ACCOUNT?</button>
                </div>
            </div>
        )
    }

    // function EnterCodeForm() {
    //     // Disable Login button if the email or password are not completed inputs.
    //     let signup_btn_class = LoginState.code === "" ? 'disabled' : '';

    //     return (
    //         <div className="">
    //             <div className="h4 text-center" style={{color: '#e05900'}}>Create {LoginState.create_account} Account</div>
    //             <div className="h4 text-center" style={{color: '#e05900'}}>The NuShoulder App is only available for elite athletes. Enter your team's {LoginState.create_account} code to be assigned to the correct program.</div>
    //             <div className="form-floating">
    //                 <input className="form-control" id="email" value={LoginState.code} onChange={(event) => changeValue('code', event.target.value)} />
    //                 <label htmlFor="code">Enter {LoginState.create_account} Code</label>
    //             </div>
    //             <div className="mt-2">
    //                 <button type="button" className={`btn text-white ${signup_btn_class}`} style={{backgroundColor: '#e05900'}} onClick={() => handleCodeSubmission()}>SUBMIT</button>
    //             </div>
    //         </div>
    //     )
    // }

    function LoginForm() {
        // Disable Login button if the email or password are not completed inputs.
        let login_btn_class = (LoginState.email === "" && LoginState.phone_number === "") || LoginState.password === "" ? 'disabled' : '';

        return (
            <div className="pb-5">
                <div className="h2 text-center mb-5" style={{color: '#e05900'}}>Login</div>
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <div className="form-floating">
                            <input className="form-control" id="email" value={LoginState.email} onChange={(event) => changeValue('email', event.target.value)} />
                            <label htmlFor="email">Coaches Enter Email</label>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="form-floating">
                            <input className="form-control" id="phone_number" value={LoginState.phone_number} onChange={(event) => changeValue('phone_number', event.target.value)} />
                            <label htmlFor="phone_number">Athletes Enter Phone Number</label>
                        </div>
                    </div>
                </div>
                <div className="form-floating mt-2">
                    <input className="form-control" id="email" value={LoginState.password} onChange={(event) => changeValue('password', event.target.value)} />
                    <label htmlFor="password">Password</label>
                </div>
                <div className="mt-2">
                    <button type="button" className={`btn text-white w-100 fw-bolder ${login_btn_class}`} style={{backgroundColor: '#e05900'}} onClick={() => handleLogin()}>LOGIN</button>
                </div>
                <img src={"/images/ns-machine.png"} alt="" className="img-fluid my-5" />
                <div className="mt-2">
                    <button type="button" className={`btn text-dark w-100 fw-bolder border border-secondary bg-white`} onClick={() => changeValue('display_form', 'password_reset')}>FORGOT PASSWORD?</button>
                </div>
                <div className="mt-2">
                    <button type="button" className={`btn text-dark w-100 fw-bolder border border-secondary bg-white`} onClick={() => changeValue('display_form', 'signup')}>SIGN UP</button>
                </div>
            </div>
        )
    }

    function PasswordResetForm() {
        let login_btn_class = LoginState.email === "" ? 'disabled' : '';
   
        return (
            <div className="">
                <div className="h4 text-center mb-5" style={{color: '#e05900'}}>Password Reset</div>
                <div className="h5">Enter your email address and we'll send you instructions on how to reset your password.</div>
                <div className="form-floating">
                    <input className="form-control" id="email" value={LoginState.email} onChange={(event) => changeValue('email', event.target.value)} />
                    <label htmlFor="email">Email</label>
                </div>
                <div className="mt-2">
                    <button type="button" className={`btn text-white ${login_btn_class}`} style={{backgroundColor: '#e05900'}} onClick={() => handlePasswordReset()}>SUBMIT</button>
                </div>
                <div className="mt-2">
                    <button type="button" className={`btn text-white`} style={{backgroundColor: '#e05900'}} onClick={() => changeValue('display_form', 'login')}>CANCEL</button>
                </div>
            </div>
        )
    }

    function SignupForm() {
        return (
            <div className="pb-5">
                <div className="h2 mb-5" style={{color: '#e05900'}}>Elite Rotator Cuff Training</div>
                <div className="h5">Which type of account do you need?</div>
                <div className="mt-2">
                    <button type="button" className={`btn w-100 fw-bolder text-white`} style={{backgroundColor: '#e05900'}} onClick={() => handleCreateAccount('Player')}>TEAM ATHLETE</button>
                </div>
                <div className="mt-2">
                    <button type="button" className={`btn w-100 fw-bolder text-white`} style={{backgroundColor: '#e05900'}} onClick={() => handleCreateAccount('Coach')}>COACH</button>
                </div>
                {/* <div className="mt-2">
                    <button type="button" className={`btn text-white`} style={{backgroundColor: '#e05900'}} onClick={() => handleCreateAccount('Regular')}>REGULAR ACCOUNT</button>
                </div> */}
                {/* <img src={process.env.PUBLIC_URL + "/images/photos/loyalpaws_cremation_visitation.jpg"} alt="" className="card-img-top" /> */}
                <img src={"/images/ns-machine.png"} alt="" className="img-fluid my-5" />
                <div className="mt-2">
                    <button type="button" className={`btn text-dark w-100 fw-bolder border border-secondary bg-white`} onClick={() => changeValue('display_form', 'login')}>ALREADY HAVE AN ACCOUNT?</button>
                </div>
            </div>
        )
    }

    console.log(auth())
    console.log({LoginState})
    
    if ( auth() === null ) {
    
        return (
            <React.Fragment>
                <div id="root-bg" style={style}></div>
                <div id="top-container" className="flex-child column-parent">	{/* TOP CONTAINER INSIDE OF ROOT */}
                    <div id="content-container" className="flex-child row-parent" style={{marginTop: 50 + 'px'}}>
                        <div id="main-content-container" className="flex-child column-parent">
                            <div id="main-content" className="flex-child row-parent">	{/* MAIN CONTENT COLUMNS */}

                                <div className="text-center">
                                    <div className="row justify-center-center">
                                        <div className="col-3"></div>
                                        <div className="col-6">
                                            <img src={"/images/nushoulder-label.png"} alt="" className="img-fluid w-100" />
                                        </div>
                                        <div className="col-3"></div>
                                    </div>
                                    <div className="row justify-content-center mt-4">
                                        {/* <div className="col-4">
                                            <img src={"/images/football-quarterback.png"} alt="" className="img-fluid" />
                                        </div> */}
                                        <div className="col-lg-6 col-md-12 col-sm-12 text-secondary border bg-light rounded py-3 px-5">

                                            {/* Default login form for email / password entry */}
                                            {LoginState.display_form === 'login' && LoginForm()}

                                            {/* Display Password Reset form */}
                                            {LoginState.display_form === 'password_reset' && PasswordResetForm()}

                                            {/* Display Signup form */}
                                            {LoginState.display_form === 'signup' && SignupForm()}

                                            {/* Display Create Account form */}
                                            {LoginState.display_form === 'create_account' && CreateAccountForm()}

                                            {/* Display Enter Code form */}
                                            {/* {LoginState.display_form === 'enter_code' && EnterCodeForm()} */}

                                        </div>
                                        {/* <div className="col-4">
                                            <img src={"/images/baseball-pitcher.png"} alt="" className="img-fluid" />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    } else {
        return (
            <Navigate to="/players" replace={true} />
        )
    }
};


                    // <div>
                    //     {/* <Link to="/login">ALREADY HAVE AN ACCOUNT?</Link> */}
                    // </div>
                    // <h4 className="mb-3">Elite Rotator Cuff Training</h4>
                    // <button onClick={() => this.setState({create_account: "player"})} style={{width: 350+'px', backgroundColor: '#ec8333', borderColor: '#ec8333'}} type="button" className="btn btn-warning btn-addon rounded mt-2">
                    // {/*  disabled={isSubmitting} */}
                    //     <FontAwesomeIcon icon="lock" />
                    //     {/* {isSubmitting ? "LOADING..." : "CREATE PLAYER ACCOUNT"} */}
                    // </button>                                        
                    // <button onClick={() => this.setState({create_account: "coach"})} style={{width: 350+'px', backgroundColor: '#ec8333', borderColor: '#ec8333'}} type="button" className="btn btn-warning btn-addon rounded mt-2">
                    //     <FontAwesomeIcon icon="lock" />
                    //     {/* {isSubmitting ? "LOADING..." : "CREATE COACH ACCOUNT"} */}
                    // </button>                                        
                    // <React.Fragment>
                    //     { Response && <div className="alert alert-danger">{Response.message}</div> }
                    //         <div>
                    //             <Field style={{width: 350+'px'}} showError={true} name="email" placeholder="Enter Email..." className={`form-control ${errors.username && touched.username && 'is-invalid'}`} />
                    //         </div>
                    //         <div className="mt-2">
                    //             <Field showError={true} autoComplete="password" type="password" name="password" placeholder="Enter Password..." className={`form-control ${errors.password && touched.password && 'is-invalid'} `} />
                    //         </div>
                    //         <div>
                    //             <Field style={{width: 350+'px'}} showError={true} name="first_name" placeholder="Enter First Name..." className={`form-control ${errors.first_name && touched.first_name && 'is-invalid'}`} />
                    //         </div>
                    //         <div>
                    //             <Field style={{width: 350+'px'}} showError={true} name="last_name" placeholder="Enter First Name..." className={`form-control ${errors.last_name && touched.last_name && 'is-invalid'}`} />
                    //         </div>
                    //         <button style={{width: 350+'px', backgroundColor: '#ec8333', borderColor: '#ec8333'}} type="submit" className="btn btn-warning btn-addon rounded mt-2" disabled={isSubmitting}>
                    //             <FontAwesomeIcon icon="lock" />
                    //             {isSubmitting ? "SIGNING UP..." : "SIGN UP"}
                    //         </button>
                    //         <div>
                    //             <Link to="/login">ALREADY HAVE AN ACCOUNT?</Link>
                    //         </div>
                    // </React.Fragment>

// export LoginComponent;
